import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const searchSeriesProgram = (SearchText, Status, locale, condition) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.SEARCH_SERIES_PROGRAM(
      SearchText,
      Status,
      locale,
      condition
    ),
    "",
    cancelToken
  );
};

export default searchSeriesProgram;
